// Node Module Imports
import React from 'react'

import PropTypes from 'prop-types'

const UtilityHeader = ({ children, className }) => (
  <div className={className}>
    <div className="position-relative text-white">
      <div className="bg--blue-chev south" />
      <div className="container">
        <div className="row d-flex justify-content-center">
          <div className="col-lg-8 text-center py-9">
            {children}
          </div>
        </div>
      </div>
    </div>
  </div>
)

UtilityHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

UtilityHeader.defaultProps = {
  className: undefined,
}

export default UtilityHeader
